import { css } from "@emotion/react"

export const colors = css`
  :root {
    // --rolex-gold: 163 126 44; // #a37e2c
    --rolex-gold: 146 108 28; // #926c1c
    --green: 18 119 73; // #127749
    --dark-green: 11 62 39; //#0b3e27
    --light-green: 36 154 100; // #127749
    --light-black: 33 33 33; // #212121
    --dark-grey: 118 118 118; // #767676
    --grey: 212 212 212; // #d4d4d4
    --alternate-grey: 216 216 216; // #d8d8d8
    --another-light-grey: 236 236 236; // #e6e6e6
    --light-grey: 248 248 248; // #f8f8f8
    --pure-white: 255 255 255; // #fff
    /*  --ocean-green: 97 189 147; // #61bd93 */
    --ocean-green: 155 249 206; // #9bf9ce
    --bronze: 116 114 102; // #747266
    --focus: var(--light-green);

    /* Gradients */
    --gradient-green-from: 16 99 61; // #10633d
    --gradient-green-to: 26 145 90; // #1a915a
    --gradient-dark-green-from: 12 76 47; // #0c4c2f
    --gradient-dark-green-to: 20 115 72; // #147348
    --gradient-qrcode-green-from: 0 107 65; // #006b41
    --gradient-qrcode-green-to: 0 55 34; // #003722
    --gradient-gold-from: 163 126 44; // #a37e2c
    --gradient-gold-to: 223 171 58; // #dfab3a
  }
  ::selection {
    background: #127749;
    color: white;
    -webkit-text-fill-color: white;
  }
`
